const REMOVE_OBJECT_KEYS = ['authorization', 'cookie', 'csrftoken', 'data'];

export const removeSensitiveData = (data: any) => {
    if (!data || typeof data !== 'object') {
        return data;
    }

    Object.keys(data).forEach((key) => {
        if (Array.isArray(data[key])) {
            data[key] = data[key].map(removeSensitiveData);
        } else if (typeof data[key] === 'object') {
            data[key] = removeSensitiveData(data[key]);
        } else if (REMOVE_OBJECT_KEYS.includes(key.toLowerCase())) {
            data[key] = '<REDACTED>';
        }
    });

    return data;
};

export const formatErrorCause = (error: Error) =>
    error.cause && error.cause instanceof Error
        ? {
              stack: error.cause.stack,
              error: error.cause.message,
              ...error.cause,
          }
        : undefined;

export const formatErrorLog = (error: any) => {
    const stack = new Error().stack;
    const message =
        typeof error === 'string' ? error : error?.message || error?.originalError?.message || error?.type || 'Error';

    return {
        message,
        error: error && typeof error === 'object' ? { stack, ...error } : { stack, error },
        cause: error && typeof error === 'object' ? formatErrorCause(error) : undefined,
    };
};
